<script setup>
import { useWindowSize } from '@vueuse/core';
const { width } = useWindowSize();

</script>
<template>
  <!-- Хлебные крошки временно отключены.
       Чтобы вернуть: раскомментировать .top-block__breadcrumbs ниже и убрать _no-breadcrumbs у .top-block.
       Компенсационные стили — в top-block.scss у .top-block._no-breadcrumbs .top-block__inner -->
  <div class="top-block _no-breadcrumbs">
    <div class="top-block__inner">
      <!-- <div class="top-block__breadcrumbs">
        <a href="/">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 8L13.6465 7.73828V16H2.35254V7.73828L0 8L8 0L16 8ZM6.11719 15.999H9.88184V10.3525H6.11719V15.999Z" fill="white"/>
          </svg>
          &nbsp;Главная
        </a>
        <svg width="5" height="7" viewBox="0 0 5 7" fill="none" xmlns="http://www.w3.org/2000/svg" class="_arrow">
          <path d="M0.5 6.5L3.5 3.5L0.5 0.5" stroke="white" stroke-linecap="round"/>
        </svg>
        <a href="/dog">Собаки</a>
        <svg width="5" height="7" viewBox="0 0 5 7" fill="none" xmlns="http://www.w3.org/2000/svg" class="_arrow">
          <path d="M0.5 6.5L3.5 3.5L0.5 0.5" stroke="white" stroke-linecap="round"/>
        </svg>
        <span>Здоровый старт с&nbsp;первых месяцев</span>
      </div> -->
      <div class="top-block__text">
        <img src="@/assets/img/logo.png" class="top-block__logo" alt="" />
        <h1 class="top-block__title">
          ЗДОРОВЫЙ СТАРТ<br/>
          <span>С ПЕРВЫХ МЕСЯЦЕВ</span>
        </h1>
      </div>
      <div class="top-block__images">
        <img src="@/assets/img/top-block-pack.png" class="top-block__pack" alt="" />
        <img src="@/assets/img/top-block-puppies.png" class="top-block__puppies" alt="" v-if="width >= 720"/>
        <img src="@/assets/img/top-block-puppy.png" class="top-block__puppies" alt="" v-else/>
      </div>
      <a href="#infoBlock" class="top-block__arrow">
        <img src="@/assets/img/arrow.svg" alt="" />
      </a>
    </div>
  </div>
</template>